<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <div
    class="card"
  >
    <div
      class="card-header d-flex align-items-center"
    >
      <SPAN>
        {{ 'Fees'|pgettext('ContractService') }}
      </SPAN>
      <SPAN
        class="badge badge-secondary ml-2"
        v-if="items && items.length"
      >
        {{ items.length }}
      </SPAN>
      <ItpFormSelect2
        name="selectedFee"
        v-model="selectedItem"
        bind-object
        :options="items"
        use-option-template-for-selected-option
        optionTemplate="<UcContractServiceFeeCard :item=&quot;option&quot;></UcContractServiceFeeCard>"
        class="ml-3"
        v-if="loaded"
        :style="b_6705964765214521_style"
      >
      </ItpFormSelect2>
      <ItpButton
        :text="'Create copy'|pgettext('Button|Command')"
        :tooltip="'Copy the selected service fee.'|pgettext('ContractServiceFeesEditor|CommandTooltip')"
        class="ml-3"
        v-if="canCreateCopy"
        @click.prevent.stop="evh_6806515264385235_clickPreventStop($event, {})"
      >
      </ItpButton>
    </div>
    <div
      class="card-content"
    >
      <ContractServiceFee
        :oid="selectedItem.id"
        :resource="selectedItem"
        no-header
        no-footer
        :displayParent="b_3943151158818434_displayParent"
        inline-commands
        v-if="selectedItem"
      >
      </ContractServiceFee>
    </div>
  </div>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UCContractServiceFeesEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getInitialSelectedItem(...args: any[]) {
    const [items] = args; const today = new Date();
    let orderedItems = _.orderBy(items, 'valid_from')
    const result = _.chain(orderedItems).filter(p => p.valid_from >= this.$fn.today && (p.valid_to == null || p.valid_to <= this.$fn.today)).head().value();
    if (!result && items.length) { return _.last(orderedItems); }
    return result;
  }

  createCopy(...args: any[]) {
    const [source] = args;
    const copy = _.cloneDeep(source);
    for (let attr of ["id", "etag", "$etag"]) {
      delete copy[attr];
    }

    if (copy.links) {
      delete copy.links["self"];
    }

    copy.valid_from = this.$fn.today();
    copy.contract_id = this.service.contract.contract_id
    copy.service_id = this.service.id

    this.items.push(copy);
    this.selectedItem = copy;
    console.log("copy crated", copy, this.selectedItem)
  }

  @Prop({
    required: true,
    type: Object,
  })
  service!: object;

  @Watch('service')
  onService(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("service")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  items!: any;

  async $$load_items() {
    return this.service.fees ? this.service.fees.slice() : []
  }

  selectedItem!: any;

  async $$load_selectedItem() {
    return this.getInitialSelectedItem(this.items)
  }

  ux!: any;
  b_6705964765214521_style!: any;
  b_3943151158818434_displayParent!: any;
  dataMembers = ['items', 'selectedItem', 'ux', 'b_6705964765214521_style', 'b_3943151158818434_displayParent'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        selectedItem: null,
        ux: null,
        b_6705964765214521_style: {
          minWidth: "300px",
        }
        ,
        b_3943151158818434_displayParent: false,
      },
    }
  }

  get canCreateCopy() {
    if (this.loaded) {

      return this.selectedItem && this.selectedItem.id != null
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_6806515264385235_script_9146_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6806515264385235_script_9146, alias=undefined
    this.createCopy(this.selectedItem)
  }

  async act_6806515264385235_script_9146_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6806515264385235_script_9146, alias=undefined
    return {
      value: () => this.act_6806515264385235_script_9146_getActionArgs_value($event),
    }
  }

  async evh_6806515264385235_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6806515264385235_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_9144: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_9143: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_6806515264385235_script_9146: actions.ScriptAction;
    evh_6806515264385235_clickPreventStop_9145: actions.EventHandlerImpl;
    evh_6806515264385235_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_9144 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_9143 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_9144,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_9143],
      }
    );
    const act_6806515264385235_script_9146 = new actions.ScriptAction(
      {
        actionArgs: this.act_6806515264385235_script_9146_getActionArgs,
        events: [],
      }
    );
    const evh_6806515264385235_clickPreventStop_9145 = new actions.EventHandlerImpl(
      {
        action: act_6806515264385235_script_9146,
        event: "click.prevent.stop",
        displayName: "script",
      }
    );
    const evh_6806515264385235_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6806515264385235_clickPreventStop_9145],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_9144,
      evh_7315092382398562_reload_9143,
      evh_7315092382398562_reload,
      act_6806515264385235_script_9146,
      evh_6806515264385235_clickPreventStop_9145,
      evh_6806515264385235_clickPreventStop,
    }
  }
}

Vue.component("UCContractServiceFeesEditor", UCContractServiceFeesEditor);

</script>